import { Grid } from 'antd';

export type UseResponsiveTabsConfigOptions = {
  mobileGutter?: number;
  desktopGutter?: number;
};

export const useResponsiveTabsConfig = (
  options: UseResponsiveTabsConfigOptions = {},
) => {
  const { mobileGutter = 10, desktopGutter = 18 } = options;
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  return {
    isMobile,
    tabSize: (isMobile ? 'small' : 'middle') as 'small' | 'middle',
    tabBarGutter: isMobile ? mobileGutter : desktopGutter,
    tabAnimated: { inkBar: true, tabPane: false } as const,
  };
};
